import {
    CREATE_POINT_OF_INTEREST_IMAGE,
    CREATE_POINT_OF_INTEREST_IMAGE_FAILURE,
    CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS,
    DELETE_POINT_OF_INTEREST_IMAGE,
    DELETE_POINT_OF_INTEREST_IMAGE_FAILURE,
    DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS,
    FETCH_POINT_OF_INTEREST_IMAGES,
    FETCH_POINT_OF_INTEREST_IMAGES_FAILURE,
    FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS,
    SET_HIGHLIGHTED_POI_IMAGE,
    SET_HIGHLIGHTED_POI_IMAGE_FAILURE,
    SET_HIGHLIGHTED_POI_IMAGE_SUCCESS,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    loading: false,
    offset: 0,
    size: 0,
    total: 0,
};

export default function productImages(state = initialState, action) {
    switch (action.type) {
        case CREATE_POINT_OF_INTEREST_IMAGE:
        case DELETE_POINT_OF_INTEREST_IMAGE:
        case FETCH_POINT_OF_INTEREST_IMAGES:
        case SET_HIGHLIGHTED_POI_IMAGE:
            return Object.assign({}, state, {
                loading: true,
            });

        case CREATE_POINT_OF_INTEREST_IMAGE_FAILURE:
        case DELETE_POINT_OF_INTEREST_IMAGE_FAILURE:
        case FETCH_POINT_OF_INTEREST_IMAGES_FAILURE:
        case SET_HIGHLIGHTED_POI_IMAGE_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS:
            let convertResultsToData = {};

            if (action.response) {
                convertResultsToData = utils.mapToObject(action.response, (value) => {
                    return value.image_id;
                });
            }

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: convertResultsToData,
                }),
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: action.response.total,
            });

        case CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS:
            const addProductImage = Object.assign(
                {},
                state.data[action.payload.id],
                {
                    [action.response.image_id]: action.response,
                }
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.payload.id]: addProductImage,
                }),
            });

        case DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS:
            const newProductImagesPayload = reducerHelper.removeItemFromObject(
                state.data[action.payload.point_of_interest_id],
                action.payload.image_id
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.payload.point_of_interest_id]: newProductImagesPayload,
                }),
            });

        case SET_HIGHLIGHTED_POI_IMAGE_SUCCESS:
            const {
                pointOfInterestId,
                response,
            } = action;

            const previousHighlightedImage = utils.find(state.data[pointOfInterestId], (image) => {
                return image.is_highlighted;
            });

            let updatePreviousImage = {};

            if (previousHighlightedImage) {
                updatePreviousImage = response.image_id !== previousHighlightedImage.image_id && {
                    [previousHighlightedImage.image_id]: {
                        ...previousHighlightedImage,
                        is_highlighted: !previousHighlightedImage.is_highlighted,
                    },
                };
            }

            const updateHighlightedPOIImage = Object.assign(
                {},
                state.data[pointOfInterestId],
                {
                    [response.image_id]: {
                        ...state.data[pointOfInterestId][response.image_id],
                        is_highlighted: response.is_highlighted,
                    },
                    ...updatePreviousImage,
                }
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [pointOfInterestId]: updateHighlightedPOIImage,
                }),
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/pointsOfInterest/pointsOfInterestImagesReducer.js